<template>
  <div :class="['main-wrap', plan == 1 ? 'plan1' : 'plan2']">
    <!--默认demo样式-->
    <form action="" v-if="plan == 1" class="login-form plan1">
      <h2>智慧物联能效平台</h2>
      <img class src="../assets/images/main/login_subtitle.png" alt="">
      <div class="form-item">
        <span>用户名</span>
        <input type="text" v-model="user_name">
      </div>
      <div class="form-item">
        <span>密码</span>
        <input type="password" v-model="pass_word" @keyup.enter="submitForm">
      </div>
      <div class="checkBox">
        <div v-if="!isCheck" class="check1Box" style="cursor:pointer" @click="onCheck"></div>
        <img v-else src="../assets/images/icon-choice-blue.png" alt="" style="cursor:pointer;" @click="onCheck">
        <p style="font-size: 14px">已阅读并同意 <span style="color:#156ad9;cursor:pointer"
                                                      @click="goTo3">《服务协议》</span></p>
      </div>
      <div class="form-item form-submit-item" @click="submitForm"></div>
    </form>
    <!-- 信息化监控平台 -->
    <template v-else>
      <img src="../assets/images/login/earth.png" alt="" class="earth-img">
      <corner-box class="login-form plan2">
        <form action="">
          <h2>中国能建集团装备有限公司</h2>
          <h2>信息化监控平台</h2>
          <p class="ENTitle">CEEECTec Information Monitoring Platform</p>
          <!--          <img class src="../assets/images/main/login_subtitle.png" alt="">-->
          <div class="form-item">
            <span>用户名</span>
            <input type="text" v-model="user_name">
          </div>
          <div class="form-item">
            <span>密码</span>
            <input type="password" v-model="pass_word" @keyup.enter="submitForm">
          </div>
          <div class="form-item form-submit-item" @click="submitForm"></div>
        </form>
      </corner-box>
    </template>

    <div style="position: fixed; bottom: 10px; text-align: center;width: 100%">
      <p style="color: #1a78f6;font-size: 13px"><span style="color: rgba(255,255,255,0.68);padding:0 20px;">Copyright©北京电力自动化设备有限公司版权所有 </span>
        <span
            style="display: inline-block; padding:0 20px; border-left: 1px  rgba(255,255,255,0.6) solid;border-right: 1px  rgba(255,255,255,0.6) solid;  cursor:pointer"
            @click="goTo1">网站备案编号：京ICP备13048381号-3</span>
        <span style="padding:0 20px;cursor:pointer" @click="goTo2">京公网安备：11010802040188号</span>
      </p>

    </div>


  </div>
</template>

<script>

import {getSession, setSession} from '@/assets/js/tools/instruments'
import cornerBox from "../components/cornerBox";
import axios from "axios"

export default {
  name: "login",
  data() {
    return {
      isCheck: false,
      user_name: '',
      pass_word: '',
      plan: ''
    };
  },
  components: {
    cornerBox
  },
  mounted() {
    this.judgeDomain();
  },
  methods: {
    judgeDomain() {
      let nowDomain = window.location.host;
      if (nowDomain.indexOf('monitoring') != -1) {
        this.plan = 2;
      } else {
        this.plan = 1;
      }
    },
    onCheck() {
      this.isCheck ? this.isCheck = false : this.isCheck = true

    },

    goTo1() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    goTo2() {
      window.open('https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502041454')
    },

    goTo3() {
      let routerJump = this.$router.resolve({path: '/agreement', query: {}});
      window.open(routerJump.href, '_blank');

    },

    submitForm() {
      let userName = this.user_name;
      if (!userName) {
        this.$message.error('请输入用户名');
        return false;
      }
      let psw = this.pass_word ? this.$md5(this.pass_word) : "";
      if (!psw) {
        this.$message.error('请输入密码');
        return false;
      }

      if (!this.isCheck) {

        this.$message.warning('请您阅读并同意服务协议');
        return
      }
      let params = {};
      params.userName = this.user_name;
      params.pwd = this.$md5(this.pass_word);
      // this.$post('login/login', params).then((response)=>{
      params.hostName = 'demo.bz-link.net'
      axios.post('http://case.bz-link.net/s1/passport/login', params).then((response) => {
        if (response.userInfo) {
          // store.state.userName = response.userInfo.userName;
          setSession("userName", response.userInfo.userName);
          // setSession("headImgSrc",response.userInfo.avatarUrl);
          this.$store.commit('changeUserPic', response.userInfo.avatarUrl)
          //项目信息
          setSession("projectInfo", JSON.stringify(response.userProjectDivisionInfo));
          //菜单
          // let temp = JSON.stringify(response.menuList);
          // setSession('menuList',temp);
          //按钮权限
          setSession('btnPermissions', response.viewList);
          //logo
          this.$cookie.set('logo', response.projectLogo, 60 * 60 * 2);
          //首页
          let indexPage = response.defaultPage;
          if (indexPage) {
            this.$router.push('/' + indexPage);
            setSession('generalSituation', indexPage == 'generalSituation' ? true : false);
            setSession('indexPage', response.defaultPage);
            this.$cookie.set('indexPage', response.defaultPage, 60 * 60 * 2);
          } else {
            this.$router.push('/login');
          }
          window.document.documentElement.setAttribute(
              "data-theme",
              JSON.parse(this.$cookie.get('indexPage') == 'GISOverview') ? "light" : "dark"
          );
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
.main-wrap {
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;

  &.plan1 {
    background-image: url("../assets/images/login/login1.png");
  }

  &.plan2 {
    background-image: url("../assets/images/login/login2.png");
  }

  .earth-img {
    position: absolute;
    left: 20%;
    top: 18%;
    width: 33%;
  }

  .login-form {
    position: absolute;
    width: 27%;
    min-width: 450px;
    height: 576px;
    padding: 4% 2%;
    top: 15%;
    right: 6%;

    h2 {
      text-align: center;
      color: #3deee7;
      font-size: 39px;
      margin-bottom: 12px;
    }

    img {
      margin-left: 67px;
    }

    .form-item {
      display: flex;
      justify-content: left;
      align-items: center;
      width: 75%;
      margin: 50px 60px auto;
      color: #1384c5;
      font-size: 18px;
      border-bottom: 1px solid #1384c5;

      input {
        width: 208px;
        line-height: 42px;
        border: none;
        outline: none;
        background-color: transparent;
        padding-left: 10px;
        color: #d3dbe5;
        font-size: 18px;
        font-weight: lighter;

        &:-webkit-autofill {
          -webkit-text-fill-color: #ededed !important;
          -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
          background-color: transparent;
          background-image: none;
          transition: background-color 50000s ease-in-out 0s;
        }
      }
    }

    .checkBox {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 75%;
      padding-top: 30px;
      margin: 0 60px;

      .check1Box {
        width: 15px;
        height: 15px;
        border: 1px solid rgba(255, 255, 255, 0.7);
        border-radius: 3px;
        margin-left: 10px;
        margin-right: 15px;
      }

      img {
        margin-left: 10px;
        margin-right: 15px;
      }

      p {
        color: rgba(255, 255, 255, 0.8);
        margin-left: 5px;
      }
    }

    .form-submit-item {
      background-image: url("../assets/images/main/submit.png");
      background-repeat: no-repeat;
      background-size: 300px 60px;
      background-position: center;
      width: 75%;
      height: 60px;
      border: none;
      cursor: pointer;
    }

    &.plan1 {
      background-image: url("../assets/images/main/login_form_bg.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
    }

    &.plan2 {
      background: rgba(0, 0, 0, 0.2);

      h2 {
        font-size: 31px;
        letter-spacing: 1px;
      }

      .ENTitle {
        color: #f00;
        font-family: "Adobe Arabic";
        font-size: 24px;
        text-align: center;
        letter-spacing: 1px;
        margin-top: 20px;
      }

      .form-item {
        margin: 45px auto;
      }
    }
  }
}
</style>
